/* Auto generated file */
/* eslint-disable */
import { SVGIconSprite, type SVGIconSpriteProps } from '../icon/SVGIconSprite';

const Check = (props: SVGIconSpriteProps) =>
    <SVGIconSprite {...props} icon="check" />;

export { Check, Check as default };
